import { useRef, useState } from "react";
import { useLayoutEffect } from "./useIsomorphicLayoutEffect";

export const useDimensions = (): [React.RefObject<HTMLDivElement | null>, DOMRect | undefined] => {
  const ref = useRef<HTMLDivElement>(null);
  const [dimensions, setDimensions] = useState<DOMRect | undefined>(undefined);

  useLayoutEffect(() => {
    const calculateDimensions = () => {
      if (ref && ref.current) {
        const boundingRect = ref.current.getBoundingClientRect();
        // Cast to JSON, so that the consumer can destructure
        setDimensions(boundingRect.toJSON());
      }
    };
    calculateDimensions();

    window.addEventListener("resize", calculateDimensions);

    return () => {
      window.removeEventListener("resize", calculateDimensions);
    };
  }, []);

  return [ref, dimensions];
};
